<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import HardwareProfileManagement from '@/components/hardware-profile/HardwareProfileManagement.vue'
import { useAuthorizationStore } from '@/stores/authorization'
import { useProjectStore } from '@/stores/project'

const authorizationStore = useAuthorizationStore()
const projectStore = useProjectStore()

const { currentItem: currentProject } = storeToRefs(projectStore)

const canManageProjectProfiles = computed(() => {
  return (
    !currentProject.value?.is_demo &&
    authorizationStore.hasServicePermission({
      authSource: 'User',
      allowed: ['add_hardwareprofile', 'change_hardwareprofile', 'delete_hardwareprofile']
    })
  )
})
</script>

<template>
  <div class="px-8 py-6">
    <HardwareProfileManagement
      v-if="currentProject?.id"
      title="Project Hardware Profiles"
      scope="project"
      :project-id="currentProject.id"
      :can-manage="canManageProjectProfiles"
    />
  </div>
</template>
